var map = {
	"./auth.js": "CAWO",
	"./building.js": "1935",
	"./buildings.js": "uvkI",
	"./childnav.js": "xxKt",
	"./folder.js": "fl62",
	"./organisation.js": "X35X",
	"./organisations.js": "uImo",
	"./user.js": "ObYA",
	"./users.js": "9ZRn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9Az";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/store/modules nonrecursive .*\.js$
// module id = d9Az
// module chunks = 21